<template>
    <div>
        <b-modal v-model="isOpenModal" id="deletChatConfirmationModal"  :hide-header="true"
                 :hide-footer="true">
            <div class="col-12 col-md-12">
                <p>{{$t('title.deleteChatConfirmMessage')}}</p>
            </div>
            <div class="modal-footer d-flex mr-2 gap-2">
                <b-button type="button" variant="primary" class="col m-0" @click="handleSubmitModal">
                    {{ $t('title.yes') }}
                </b-button>
                <b-button type="button" variant="secondary" class="col m-0" @click="cancelModal">
                    {{ $t('title.cancel') }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {request} from "@/Util/Request";
import Error from "@/Util/Error";
export default {
    data() {
        return {
            isOpenModal: false,
            chat_id: null
        };
    },
    methods: {
        async handleToggleModal(id=null) {
            this.isOpenModal = !this.isOpenModal;
            this.chat_id = id;
        },
        async handleSubmitModal() {
            const response = await request({
                method: 'post',
                url: `/admin/delete-chat-history/${this.chat_id}`
            });
            
            if(response) {
                this.cancelModal();
                this.$emit('chatHistoryList');
            }
            
            console.log(response);
        },
        cancelModal() {
            this.isOpenModal = false;
        }
    }
};
</script>
